/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseTypeDto } from './CaseTypeDto';
import {
    CaseTypeDtoFromJSON,
    CaseTypeDtoFromJSONTyped,
    CaseTypeDtoToJSON,
    CaseTypeDtoToJSONTyped,
} from './CaseTypeDto';

/**
 * 
 * @export
 * @interface CaseTypeResponse
 */
export interface CaseTypeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CaseTypeResponse
     */
    success?: boolean;
    /**
     * 
     * @type {CaseTypeDto}
     * @memberof CaseTypeResponse
     */
    data?: CaseTypeDto;
    /**
     * 
     * @type {string}
     * @memberof CaseTypeResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the CaseTypeResponse interface.
 */
export function instanceOfCaseTypeResponse(value: object): value is CaseTypeResponse {
    return true;
}

export function CaseTypeResponseFromJSON(json: any): CaseTypeResponse {
    return CaseTypeResponseFromJSONTyped(json, false);
}

export function CaseTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : CaseTypeDtoFromJSON(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function CaseTypeResponseToJSON(json: any): CaseTypeResponse {
    return CaseTypeResponseToJSONTyped(json, false);
}

export function CaseTypeResponseToJSONTyped(value?: CaseTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': CaseTypeDtoToJSON(value['data']),
        'error': value['error'],
    };
}

